var _path, _path2, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6843 8.36749C16.6843 6.70359 16.0234 5.10784 14.8468 3.93129C13.6703 2.75473 12.0745 2.09375 10.4106 2.09375C8.74671 2.09375 7.15096 2.75473 5.97441 3.93129C4.79785 5.10784 4.13687 6.70359 4.13687 8.36749C4.13687 15.6869 1 17.7781 1 17.7781H19.8212C19.8212 17.7781 16.6843 15.6869 16.6843 8.36749Z",
    stroke: "url(#paint0_linear_5577_4230)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2194 21.9609C12.0356 22.2778 11.7717 22.5409 11.4543 22.7237C11.1368 22.9066 10.7769 23.0029 10.4105 23.0029C10.0441 23.0029 9.68419 22.9066 9.36672 22.7237C9.04925 22.5409 8.78539 22.2778 8.60156 21.9609",
    stroke: "url(#paint1_linear_5577_4230)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.547,
    cy: 3.13657,
    rx: 3.13687,
    ry: 3.13687,
    transform: "rotate(-90 13.547 3.13657)",
    fill: "url(#paint2_linear_5577_4230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5577_4230",
    x1: 10.4106,
    y1: 2.09375,
    x2: 10.4106,
    y2: 17.7781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5577_4230",
    x1: 10.5,
    y1: 19,
    x2: 10.4105,
    y2: 23.0029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5577_4230",
    x1: 10.4102,
    y1: 3.13583,
    x2: 16.6835,
    y2: 3.13583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0C0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9965549ae952645dc810703280112e13.svg";
export { ForwardRef as ReactComponent };